import statusHistory from './statusHistory'

const logs = {
  statusHistory,
}

export default logs
